import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const AdminEmbedPage = () => {
  const [copied, setCopied] = useState(false);
  
  const currentDomain = window.location.origin;
  
  const embedCode = `<iframe 
  src="${currentDomain}" 
  width="100%" 
  height="800" 
  frameborder="0"
  title="Pet Food Quiz">
</iframe>`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(embedCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="admin-container">
      <Link to="/" className="back-link">← Back to Home</Link>
      
      <h1 className="admin-title">Embed Pet Food Quiz</h1>
      
      <div style={{ marginBottom: '30px' }}>
        <p style={{ color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6' }}>
          Use this embed code to add the Pet Food Quiz to your website, blog, or any HTML page. 
          The quiz will appear as an interactive iframe that your visitors can use directly.
        </p>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3 style={{ color: '#1e293b', marginBottom: '10px' }}>Embed Code:</h3>
        <div className="embed-code">
          {embedCode}
        </div>
      </div>
      
      <button 
        className={`copy-button ${copied ? 'copied' : ''}`}
        onClick={copyToClipboard}
        style={{
          background: copied ? '#059669' : '#3b82f6',
          marginBottom: '30px'
        }}
      >
        {copied ? '✓ Copied!' : '📋 Copy Embed Code'}
      </button>

      <div style={{ 
        background: '#f8fafc', 
        padding: '20px', 
        borderRadius: '12px',
        border: '1px solid #e2e8f0',
        marginBottom: '30px'
      }}>
        <h4 style={{ color: '#1e293b', marginBottom: '15px' }}>
          📝 How to Use:
        </h4>
        <ol style={{ color: '#64748b', lineHeight: '1.6' }}>
          <li>Copy the embed code above</li>
          <li>Paste it into your website's HTML where you want the quiz to appear</li>
          <li>Adjust the width and height attributes if needed</li>
          <li>Save and publish your page</li>
        </ol>
      </div>

      <div style={{ 
        background: '#fef3c7', 
        padding: '20px', 
        borderRadius: '12px',
        border: '1px solid #fbbf24',
        marginBottom: '30px'
      }}>
        <h4 style={{ color: '#92400e', marginBottom: '10px' }}>
          ⚡ Features:
        </h4>
        <ul style={{ color: '#78350f', lineHeight: '1.6', margin: 0 }}>
          <li>Fully responsive design</li>
          <li>Works on all devices and screen sizes</li>
          <li>Collects leads automatically via Airtable</li>
          <li>Generates personalized recommendations using AI</li>
          <li>Shareable result links for each user</li>
        </ul>
      </div>

      <div style={{ textAlign: 'center' }}>
        <Link to="/quiz" className="btn btn-secondary" style={{ marginRight: '15px' }}>
          Test Quiz
        </Link>
        <Link to="/" className="cta-button">
          Back to Home
        </Link>
      </div>

      {/* Preview Section */}
      <div style={{ marginTop: '50px' }}>
        <h3 style={{ color: '#1e293b', marginBottom: '20px', textAlign: 'center' }}>
          📱 Live Preview:
        </h3>
        <div style={{ 
          border: '2px solid #e2e8f0', 
          borderRadius: '12px', 
          overflow: 'hidden',
          background: '#f8fafc'
        }}>
          <iframe 
            src={currentDomain} 
            width="100%" 
            height="600" 
            frameBorder="0"
            title="Pet Food Quiz Preview"
            style={{ display: 'block' }}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminEmbedPage;